export function setMembers (state, members) {
	state.members = [ ...members ];
}
